import { render } from "./edytujOgloszenie.vue?vue&type=template&id=39b9dc1d&scoped=true"
import script from "./edytujOgloszenie.vue?vue&type=script&lang=js"
export * from "./edytujOgloszenie.vue?vue&type=script&lang=js"

import "./edytujOgloszenie.vue?vue&type=style&index=0&id=39b9dc1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b9dc1d"]])

export default __exports__